import $axios from "../api/accessor";
import { $api } from "../api/api";
import { getCookie } from "../utils/utils";
const token = getCookie("BscAdminToken");
export const RolesService = {
  async getAllRoles() {
    let response = await $axios.get($api("roles")).catch((err) => {
      return err.response;
    });
    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },

  async addRole(payload: any) {
    try {
      const { data, status } = await $axios.post($api("roles"), payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return { data, status };
    } catch (err: any) {
      const errorMessage = err.response?.data?.message;
      return { data: null, status: err.response?.status, errorMessage };
    }
  },

  async updateRole(payload: any) {
    try {
      const { data, status } = await $axios.put(
        $api("roles_id", { id: payload.id }),
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return { data, status };
    } catch (err: any) {
      const errorMessage = err.response?.data?.message;
      return { data: null, status: err.response?.status, errorMessage };
    }
  },

  async deleteRole(id: string) {
    let { data, status } = await $axios
      .delete($api("roles_id", { id }), {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .catch((err) => {
        return err.response;
      });
    return { data, status };
  },

  async getRolesWithPermissions() {
    let response = await $axios
      .get($api("roles_with_permissions"))
      .catch((err) => {
        return err.response;
      });
    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },

  async getAllPermissions() {
    let response = await $axios.get($api("permissions")).catch((err) => {
      return err.response;
    });
    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },

  async addPermission(id: number, permission: any) {
    try {
      const { data, status } = await $axios.post(
        $api("roles_add_permissions", { id }),
        permission,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return { data, status };
    } catch (err: any) {
      const errorMessage = err.response?.data?.message;
      return { data: null, status: err.response?.status, errorMessage };
    }
  },

  async removePermission(id: number, permission: any) {
    let { data, status } = await $axios
      .delete($api("roles_remove_permissions", { id }), {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: permission,
      })
      .catch((err) => {
        return err.response;
      });
    return { data, status };
  },
};
